import { useCallback, useState, useMemo } from 'react';
import { Button, Icon, Menus } from '@Sage/hoi-poi-ui';

import VideoModal from 'components/VideoModal';
import { getLiteral } from 'utils/getLiteral';
import { logEvent } from 'utils/tracking';

import './styles.scss';
import { isEmpty } from '../../utils/isEmpty';

const HELP_MENU_POPOVER_Z = 10000000;

const AutomationsHelpActions = (props) => {
    const {
        className,
        helpCenterLabel = getLiteral('label_support'),
        helpMenuClassName,
        knowledgeMoreLabel = getLiteral('action_automations_knowledge_base'),
        knowledgeMoreUrl = getLiteral('label_automations_knowledge_base_all_links'),
        trackingEvent = 'settings',
        videoTutorialLabel = getLiteral('action_automations_video_tutorial'),
        videoTutorialUrl = getLiteral('label_automations_video_tutorial_link'),
    } = props;

    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const openVideoTutorial = useCallback(() => {
        setIsVideoModalOpen(true);
        logEvent({
            event: trackingEvent,
            functionality: 'openVideoTutorial',
            submodule: 'automationsTemplate',
        });
    }, [trackingEvent]);

    const closeVideoModal = useCallback(() => {
        setIsVideoModalOpen(false);
    }, []);

    const openKnowledgeBase = useCallback(() => {
        if (isEmpty(knowledgeMoreUrl)) return;

        window.open(knowledgeMoreUrl, '_blank');
        logEvent({
            event: trackingEvent,
            functionality: 'openKnowledgeBase',
            submodule: 'automationsTemplate',
        });
    }, [trackingEvent, knowledgeMoreUrl]);

    const openSupportChat = useCallback(() => {
        if (!window.Intercom) return;
        window.Intercom('showNewMessage');
        logEvent({
            event: trackingEvent,
            functionality: 'openSupportChat',
            submodule: 'automationsTemplate',
        });
    }, [trackingEvent]);

    const helpMenuItems = useMemo(() => {
        const items = [
            {
                icon: <Icon name="helpOutline" />,
                title: knowledgeMoreLabel,
                onClick: openKnowledgeBase,
            },
        ];
        if (window.Intercom) {
            items.push({
                icon: <Icon name="comment" />,
                title: getLiteral('action_support_chat'),
                onClick: openSupportChat,
            });
        }
        return items;
    }, [knowledgeMoreLabel, openKnowledgeBase, openSupportChat]);

    const helpMenuOverlayStyle = useMemo(() => ({ zIndex: HELP_MENU_POPOVER_Z }), []);

    return (
        <>
            <div className={className || 'fm-automations-help-actions'}>
                <Button
                    icon="playCircleFilled"
                    onClick={openVideoTutorial}
                    size="small"
                    type="terciary"
                >
                    {videoTutorialLabel}
                </Button>
                <Menus
                    classNameMenu={helpMenuClassName}
                    items={helpMenuItems}
                    overlayStyle={helpMenuOverlayStyle}
                    placement="bottom-end"
                    size="medium"
                    title={
                        <Button icon="helpOutline" size="small" type="terciary">
                            {helpCenterLabel}
                        </Button>
                    }
                />
            </div>
            <VideoModal
                isOpen={isVideoModalOpen}
                onRequestClose={closeVideoModal}
                title={videoTutorialLabel}
                videoUrl={videoTutorialUrl}
            />
        </>
    );
};

AutomationsHelpActions.displayName = 'AutomationsHelpActions';

export default AutomationsHelpActions;
